import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
const ViewMain = React.lazy(() =>
  import(/* webpackChunkName: "views" */ './views')
);


function App() {
  return (<>
    <ToastContainer
      delay={3000}
      position={'top-center'}
      theme="dark"
    />


    <React.Fragment>
      <Router>
        <Switch>
          <Route
            path="/"
            render={props => <ViewMain {...{ ...props }} />}
          />

        </Switch>
      </Router>
    </React.Fragment>

  </>
  );
}

export default App;
